import { ErrorHandler } from 'app/_services/error-handler.factory';
import * as angular from 'angular';
import { TransmissionSystemOperatorResource } from 'app/_resources/transmission-system-operator.resource';
import { Growl } from 'angular/custom/services/growl.service';

class CreateMaintenanceMessageComponentCtrl implements ng.IController {
    private tsoRefId: number;
    private onSuccess: Function;
    private maintenancePeriod: DateInterval;
    private maintenanceMessage: MaintenanceMessageDto;
    private submitting: boolean;
    private form: ng.IFormController;

    constructor(
        private TransmissionSystemOperator: TransmissionSystemOperatorResource,
        private growl: Growl,
        private errorHandler: ErrorHandler
    ) {}

    $onInit(): void {
        if (!angular.isUndefined(this.maintenanceMessage)) {
            this.maintenanceMessage = angular.copy(this.maintenanceMessage);
        }
    }

    submit(): ng.IPromise<MaintenanceMessageDto> {
        this.submitting = true;

        return this.TransmissionSystemOperator.saveMaintenanceMessage(
            {
                id: this.tsoRefId,
                maintenanceMessageId: this.maintenanceMessage.id
            },
            this.maintenanceMessage,
            (res: MaintenanceMessageDto) => {
                this.growl.show('Successfully saved.', 'success');
                this.onSuccess({ savedMaintenanceMessage: res });
                this.form.$setPristine();
                this.form.$setUntouched();
                this.form.$submitted = false;
                this.maintenanceMessage = null;
            },
            this.errorHandler
        ).$promise.finally(() => (this.submitting = false));
    }
}

angular.module('app').component('pkpCreateMaintenanceMessage', {
    controller: CreateMaintenanceMessageComponentCtrl,
    template:
        require('app/maintenance-messages/create-maintenance-message.component.html'),
    bindings: {
        tsoRefId: '<',
        onSuccess: '&',
        maintenanceMessage: '<'
    }
});
